import { FlexContainer } from '@facephi/ui-react';
import styled from 'styled-components';

export const TableHeaderStyles = styled(FlexContainer)<{
  hasPadding?: boolean;
}>`
  width: 100%;
  ${(props) => props.hasPadding && `padding: 1.6rem 2.4rem;`}
`;
